import { apiInterfaceForJson } from "../common/apiManager";

export const fetchLeadStatuses = () => {
    return apiInterfaceForJson("/leadStatus/v1/", "GET");
};

export const createLeadStatus = (leadStatusData) => {
    return apiInterfaceForJson("/leadStatus/v1/", "POST", leadStatusData);
};

export const updateLeadStatus = (leadStatusData) => {
    return apiInterfaceForJson("/leadStatus/v1/", "PUT", leadStatusData);
};

export const approveLeadStatus = (approvalData) => {
    return apiInterfaceForJson("/leadStatus/v1/approve", "POST", approvalData);
};

export const rejectLeadStatus = (leadStatusId) => {
    return apiInterfaceForJson("/leadStatus/v1/reject", "POST", { leadStatusId });
};

export const getLeadStatusHistory = (leadId) => {
    return apiInterfaceForJson(`/leadStatus/v1/history/${leadId}`, "GET");
};

export const deleteLeadStatus = (leadStatusId) => {
    return apiInterfaceForJson("/leadStatus/v1/delete", "POST", { _id: leadStatusId });
};
